import { ReactNode } from "react";
import { Box, BoxProps, Container } from "@mui/material";
// import styled form '@mui/material/styles' because styled from '@mui/system' doesnt pass styles
import { styled, Theme } from "@mui/material/styles";

import { checkErrors, getDefaultOptions } from "../services/Category";
import { getCookie, setCookie } from "../services/utils";
import { RevbellMenuItem } from "./Menu/Menu";
import { ROLES_MAP } from "../AuthProvider";
import { BannerType } from "../Banner/interfaces";

export const DRAWER_WIDTH = 60;
export const DRAWER_WIDTH_OPEN = 250;
export const SUB_DRAWER_WIDTH_OPEN = 250;
export const PINNED_WINDOW_WIDTH_MIN_SIZE = 1700;
export const MOBILE_QUERY = 960;

interface RevbellBoxProps extends BoxProps {
  gap?: number;
  flex?: string;
}

export interface LayoutProps {
  children: ReactNode | ReactNode[];
}

export const Column = styled(Box)<RevbellBoxProps>(
  ({ gap = 0, flex = "1", theme }) => ({
    display: "flex",
    flex,
    flexDirection: "column",
    gap: theme.spacing(gap),
  })
);

export const Row = styled(({ gap, ...other }: RevbellBoxProps) => (
  <Box {...other} />
))(({ gap = 0, theme }: RevbellBoxProps & { theme: Theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(gap),
}));

export const Main = styled("main")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  width: "100%",
  paddingTop: theme.spacing(2),
}));

export const StretchContainer = styled(Container)({
  display: "flex",
  flex: "1 1 auto",
});

const manageRoles = (roles: string[]) => {
  return roles.map((role) => {
    return ROLES_MAP[role as keyof typeof ROLES_MAP];
  });
};

export const listMenus = async () => {
  const response = await fetch(
    "/api/modules/?is_enabled=true",
    getDefaultOptions()
  );

  const data = await response.json();
  const menuItems: RevbellMenuItem[] = data.map((x: any) => ({
    id: x.id,
    isReactPage: x.is_react_page,
    name: x.name,
    rang: x.rang,
    translated_name: x.translated_name,
    reactRoute: x.react_route,
    slug: x.slug,
    urlPath: x.url_path,
    allowedRoles: manageRoles(x.allowed_roles ? x.allowed_roles : []),
  }));

  checkErrors(response);

  return menuItems;
};

/**
 * Get revbell menu cookie
 */
export const getMenuData = () => {
  if (typeof window === "undefined")
    return { pinned: false, collapseState: {} };

  const cookie = getCookie("revbell-menu");

  if (cookie) {
    return JSON.parse(cookie);
  } else {
    setCookie(
      "revbell-menu",
      JSON.stringify({ pinned: false, collapseState: {} })
    );
  }

  return { pinned: false, collapseState: {} };
};

export const getCurrentBanner = async (): Promise<BannerType | null> => {
  const response = await fetch("/api/banners/displayed/", {
    ...getDefaultOptions(),
    method: "GET",
  });

  checkErrors(response);

  // A list, empty when there is none: only its first banner is shown for now.
  const banners: BannerType[] = await response.json();
  return banners[0] ?? null;
};
